const normalizeText = (value) => String(value || "").trim().toLowerCase();

/** Wikimedia thumbnails where clubs are absent or ambiguous on api-sports. */
const WIKI_LOGO = {
  blackpool:
    "https://upload.wikimedia.org/wikipedia/en/thumb/d/df/Blackpool_FC_logo.svg/330px-Blackpool_FC_logo.svg.png",
  bradfordPA:
    "https://upload.wikimedia.org/wikipedia/en/6/62/Bradford_%28Park_Avenue%29_A.F.C._logo.png",
  bury: "https://upload.wikimedia.org/wikipedia/en/thumb/6/65/Bury_FC_crest.svg/330px-Bury_FC_crest.svg.png",
  darwen: "https://upload.wikimedia.org/wikipedia/en/f/fe/Darwen_FC_crest.png",
  glossopNE: "https://upload.wikimedia.org/wikipedia/en/5/5e/GNE_afc_badge.png",
  grimsby:
    "https://upload.wikimedia.org/wikipedia/en/thumb/d/db/Grimsby_Town_F.C._logo.svg/330px-Grimsby_Town_F.C._logo.svg.png",
  leytonOrient:
    "https://upload.wikimedia.org/wikipedia/en/thumb/a/a8/Leyton_Orient_F.C._logo.svg/330px-Leyton_Orient_F.C._logo.svg.png",
  wimbledon:
    "https://upload.wikimedia.org/wikipedia/en/thumb/b/b3/Wimbledon_FC_crest.svg/330px-Wimbledon_FC_crest.svg.png",
};

/** api-sports.io crest URLs (and a few Wikimedia URLs) keyed by normalized CSV / UI names */
export const EPL_TEAM_LOGO_URLS = {
  accrington: "https://media.api-sports.io/football/teams/1355.png",
  "accrington stanley": "https://media.api-sports.io/football/teams/1355.png",
  arsenal: "https://media.api-sports.io/football/teams/42.png",
  "aston villa": "https://media.api-sports.io/football/teams/66.png",
  barnsley: "https://media.api-sports.io/football/teams/747.png",
  birmingham: "https://media.api-sports.io/football/teams/54.png",
  "birmingham city": "https://media.api-sports.io/football/teams/54.png",
  blackburn: "https://media.api-sports.io/football/teams/67.png",
  "blackburn rovers": "https://media.api-sports.io/football/teams/67.png",
  blackpool: WIKI_LOGO.blackpool,
  bournemouth: "https://media.api-sports.io/football/teams/35.png",
  bolton: "https://media.api-sports.io/football/teams/68.png",
  "bolton wanderers": "https://media.api-sports.io/football/teams/68.png",
  "bradford city": "https://media.api-sports.io/football/teams/1347.png",
  "bradford pa": WIKI_LOGO.bradfordPA,
  "bradford park avenue": WIKI_LOGO.bradfordPA,
  brentford: "https://media.api-sports.io/football/teams/55.png",
  brighton: "https://media.api-sports.io/football/teams/51.png",
  "brighton & hove albion": "https://media.api-sports.io/football/teams/51.png",
  "bristol city": "https://media.api-sports.io/football/teams/56.png",
  burnley: "https://media.api-sports.io/football/teams/44.png",
  bury: WIKI_LOGO.bury,
  "cardiff city": "https://media.api-sports.io/football/teams/43.png",
  "carlisle united": "https://media.api-sports.io/football/teams/1339.png",
  "charlton ath": "https://media.api-sports.io/football/teams/748.png",
  "charlton athletic": "https://media.api-sports.io/football/teams/748.png",
  charlton: "https://media.api-sports.io/football/teams/748.png",
  chelsea: "https://media.api-sports.io/football/teams/49.png",
  coventry: "https://media.api-sports.io/football/teams/1346.png",
  "coventry city": "https://media.api-sports.io/football/teams/1346.png",
  "crystal palace": "https://media.api-sports.io/football/teams/52.png",
  darwen: WIKI_LOGO.darwen,
  "derby county": "https://media.api-sports.io/football/teams/69.png",
  derby: "https://media.api-sports.io/football/teams/69.png",
  everton: "https://media.api-sports.io/football/teams/45.png",
  fulham: "https://media.api-sports.io/football/teams/36.png",
  "glossop ne": WIKI_LOGO.glossopNE,
  "glossop north end": WIKI_LOGO.glossopNE,
  grimsby: WIKI_LOGO.grimsby,
  "grimsby town": WIKI_LOGO.grimsby,
  huddersfield: "https://media.api-sports.io/football/teams/37.png",
  "huddersfield town": "https://media.api-sports.io/football/teams/37.png",
  hull: "https://media.api-sports.io/football/teams/73.png",
  "hull city": "https://media.api-sports.io/football/teams/73.png",
  ipswich: "https://media.api-sports.io/football/teams/57.png",
  "ipswich town": "https://media.api-sports.io/football/teams/57.png",
  leeds: "https://media.api-sports.io/football/teams/63.png",
  "leeds united": "https://media.api-sports.io/football/teams/63.png",
  leicester: "https://media.api-sports.io/football/teams/46.png",
  "leicester city": "https://media.api-sports.io/football/teams/46.png",
  "leyton orient": WIKI_LOGO.leytonOrient,
  liverpool: "https://media.api-sports.io/football/teams/40.png",
  luton: "https://media.api-sports.io/football/teams/1359.png",
  "luton town": "https://media.api-sports.io/football/teams/1359.png",
  "man city": "https://media.api-sports.io/football/teams/50.png",
  "man utd": "https://media.api-sports.io/football/teams/33.png",
  "manchester city": "https://media.api-sports.io/football/teams/50.png",
  "manchester utd": "https://media.api-sports.io/football/teams/33.png",
  "manchester united": "https://media.api-sports.io/football/teams/33.png",
  middlesbrough: "https://media.api-sports.io/football/teams/76.png",
  millwall: "https://media.api-sports.io/football/teams/72.png",
  "newcastle united": "https://media.api-sports.io/football/teams/34.png",
  "newcastle utd": "https://media.api-sports.io/football/teams/34.png",
  "newton heath": "https://media.api-sports.io/football/teams/33.png",
  northampton: "https://media.api-sports.io/football/teams/1333.png",
  "northampton town": "https://media.api-sports.io/football/teams/1333.png",
  norwich: "https://media.api-sports.io/football/teams/71.png",
  "norwich city": "https://media.api-sports.io/football/teams/71.png",
  "nott'ham forest": "https://media.api-sports.io/football/teams/65.png",
  "nottingham forest": "https://media.api-sports.io/football/teams/65.png",
  "notts county": "https://media.api-sports.io/football/teams/7234.png",
  oldham: "https://media.api-sports.io/football/teams/1334.png",
  "oldham athletic": "https://media.api-sports.io/football/teams/1334.png",
  "oxford united": "https://media.api-sports.io/football/teams/1338.png",
  portsmouth: "https://media.api-sports.io/football/teams/1350.png",
  preston: "https://media.api-sports.io/football/teams/59.png",
  "preston north end": "https://media.api-sports.io/football/teams/59.png",
  qpr: "https://media.api-sports.io/football/teams/70.png",
  "queens park rangers": "https://media.api-sports.io/football/teams/70.png",
  reading: "https://media.api-sports.io/football/teams/53.png",
  "sheffield united": "https://media.api-sports.io/football/teams/62.png",
  "sheffield utd": "https://media.api-sports.io/football/teams/62.png",
  "sheffield wednesday": "https://media.api-sports.io/football/teams/64.png",
  "sheffield weds": "https://media.api-sports.io/football/teams/64.png",
  "small heath": "https://media.api-sports.io/football/teams/54.png",
  southampton: "https://media.api-sports.io/football/teams/41.png",
  stoke: "https://media.api-sports.io/football/teams/75.png",
  "stoke city": "https://media.api-sports.io/football/teams/75.png",
  sunderland: "https://media.api-sports.io/football/teams/746.png",
  "swansea city": "https://media.api-sports.io/football/teams/74.png",
  swindon: "https://media.api-sports.io/football/teams/1360.png",
  "swindon town": "https://media.api-sports.io/football/teams/1360.png",
  "the wednesday": "https://media.api-sports.io/football/teams/64.png",
  tottenham: "https://media.api-sports.io/football/teams/47.png",
  "tottenham hotspur": "https://media.api-sports.io/football/teams/47.png",
  watford: "https://media.api-sports.io/football/teams/38.png",
  "west brom": "https://media.api-sports.io/football/teams/60.png",
  "west bromwich albion": "https://media.api-sports.io/football/teams/60.png",
  "west ham": "https://media.api-sports.io/football/teams/48.png",
  "west ham united": "https://media.api-sports.io/football/teams/48.png",
  wigan: "https://media.api-sports.io/football/teams/61.png",
  "wigan athletic": "https://media.api-sports.io/football/teams/61.png",
  wimbledon: WIKI_LOGO.wimbledon,
  wolves: "https://media.api-sports.io/football/teams/39.png",
  "wolverhampton wanderers": "https://media.api-sports.io/football/teams/39.png",
};

export function getEplTeamLogoUrl(teamName) {
  return EPL_TEAM_LOGO_URLS[normalizeText(teamName)] || null;
}
